import { ReportEventEditorFields } from '@/components/ReportEventEditor';
import type { ReportEventDraft, ReportEventDraftEdits } from '@/types/report';
import { SourceType } from '@/types/source';
import { AddEventsToReportSidebar } from './AddEventsToReportSidebar';

interface AddEventsToReportContentProps {
    drafts: ReportEventDraft[];
    selectedDraft: ReportEventDraft;
    validationVisible: boolean;
    managePopoverOpen: boolean;
    onManagePopoverOpenChange: (open: boolean) => void;
    onSelect: (eventId: string) => void;
    onRemove: (eventId: string) => void;
    onEditSelected: (edits: Partial<ReportEventDraftEdits>) => void;
    onStartAddThumbnail: () => void;
    promptTextError?: string;
}

export function AddEventsToReportContent({
    drafts,
    selectedDraft,
    validationVisible,
    managePopoverOpen,
    onManagePopoverOpenChange,
    onSelect,
    onRemove,
    onEditSelected,
    onStartAddThumbnail,
    promptTextError,
}: AddEventsToReportContentProps) {
    return (
        <div className="flex h-full min-h-0">
            <AddEventsToReportSidebar
                drafts={drafts}
                selectedEventId={selectedDraft.event.id}
                validationVisible={validationVisible}
                onSelect={onSelect}
                onRemove={onRemove}
            />
            <div className="w-px shrink-0 bg-grey-500" aria-hidden />
            <div className="min-h-0 flex-1 overflow-y-auto scrollbar-hide">
                <ReportEventEditorFields
                    sourceId={selectedDraft.event.sourceId}
                    thumbnails={selectedDraft.thumbnails}
                    promptText={selectedDraft.promptText}
                    description={selectedDraft.description}
                    promptTextError={promptTextError}
                    addThumbnailDisabled={
                        selectedDraft.event.sourceType !== SourceType.FILE
                    }
                    managePopoverOpen={managePopoverOpen}
                    onManagePopoverOpenChange={onManagePopoverOpenChange}
                    onPromptTextChange={(promptText) =>
                        onEditSelected({ promptText })
                    }
                    onDescriptionChange={(description) =>
                        onEditSelected({ description })
                    }
                    onThumbnailsChange={(thumbnails) =>
                        onEditSelected({ thumbnails })
                    }
                    onStartAddThumbnail={onStartAddThumbnail}
                />
            </div>
        </div>
    );
}
